import type { SupportedLocale } from './config';

export type PasswordResetValidationCopy = {
  emailValidation: string;
  passwordResetMinimumValidation: string;
  confirmPasswordValidation: string;
  passwordsDoNotMatch: string;
};

const COPY_BY_LOCALE: Record<SupportedLocale, PasswordResetValidationCopy> = {
  en: {
    emailValidation: 'Please enter a valid email address',
    passwordResetMinimumValidation: 'Password must be at least 8 characters',
    confirmPasswordValidation: 'Confirm your new password',
    passwordsDoNotMatch: 'Passwords do not match',
  },
  'pt-BR': {
    emailValidation: 'Por favor, digite um endere\u00E7o de e-mail v\u00E1lido',
    passwordResetMinimumValidation: 'A senha deve ter pelo menos 8 caracteres.',
    confirmPasswordValidation: 'Confirme sua nova senha.',
    passwordsDoNotMatch: 'Senhas n\u00E3o batem.',
  },
  ar: {
    emailValidation: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    passwordResetMinimumValidation:
      'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    confirmPasswordValidation: 'أكّد كلمة المرور الجديدة',
    passwordsDoNotMatch: 'كلمتا المرور غير متطابقتين',
  },
  es: {
    emailValidation: 'Introduce una dirección de email válida',
    passwordResetMinimumValidation:
      'La contraseña debe tener al menos 8 caracteres',
    confirmPasswordValidation: 'Confirma tu nueva contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
  },
  fr: {
    emailValidation: 'Saisissez une adresse e-mail valide',
    passwordResetMinimumValidation:
      'Le mot de passe doit contenir au moins 8 caractères',
    confirmPasswordValidation: 'Confirmez votre nouveau mot de passe',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
  },
  it: {
    emailValidation: 'Inserisci un indirizzo email valido',
    passwordResetMinimumValidation:
      'La password deve contenere almeno 8 caratteri',
    confirmPasswordValidation: 'Conferma la nuova password',
    passwordsDoNotMatch: 'Le password non corrispondono',
  },
  ko: {
    emailValidation: '올바른 이메일 주소를 입력하세요',
    passwordResetMinimumValidation: '비밀번호는 8자 이상이어야 합니다',
    confirmPasswordValidation: '새 비밀번호를 다시 입력하세요',
    passwordsDoNotMatch: '비밀번호가 일치하지 않습니다',
  },
  de: {
    emailValidation: 'Gib eine gültige E-Mail-Adresse ein',
    passwordResetMinimumValidation:
      'Das Passwort muss mindestens 8 Zeichen lang sein',
    confirmPasswordValidation: 'Bestätige dein neues Passwort',
    passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
  },
  ja: {
    emailValidation: '有効なメールアドレスを入力してください',
    passwordResetMinimumValidation: 'パスワードは8文字以上で入力してください',
    confirmPasswordValidation: '確認用パスワードを入力してください',
    passwordsDoNotMatch: 'パスワードが一致しません',
  },
  hi: {
    emailValidation: 'मान्य ईमेल पता दर्ज करें',
    passwordResetMinimumValidation: 'पासवर्ड कम से कम 8 अक्षरों का होना चाहिए',
    confirmPasswordValidation: 'नए पासवर्ड की पुष्टि करें',
    passwordsDoNotMatch: 'पासवर्ड मेल नहीं खाते',
  },
  ru: {
    emailValidation: 'Введите действительный адрес электронной почты',
    passwordResetMinimumValidation:
      'Пароль должен содержать не менее 8 символов',
    confirmPasswordValidation: 'Подтвердите новый пароль',
    passwordsDoNotMatch: 'Пароли не совпадают',
  },
  zh: {
    emailValidation: '请输入有效的电子邮箱地址',
    passwordResetMinimumValidation: '密码至少需要 8 个字符',
    confirmPasswordValidation: '请确认新密码',
    passwordsDoNotMatch: '两次输入的密码不一致',
  },
  'zh-TW': {
    emailValidation: '請輸入有效的電子郵件地址',
    passwordResetMinimumValidation: '密碼至少需要 8 個字元',
    confirmPasswordValidation: '請確認新密碼',
    passwordsDoNotMatch: '兩次輸入的密碼不一致',
  },
  vi: {
    emailValidation: 'Vui lòng nhập địa chỉ email hợp lệ',
    passwordResetMinimumValidation: 'Mật khẩu phải có ít nhất 8 ký tự',
    confirmPasswordValidation: 'Xác nhận mật khẩu mới',
    passwordsDoNotMatch: 'Mật khẩu không khớp',
  },
  id: {
    emailValidation: 'Masukkan alamat email yang valid',
    passwordResetMinimumValidation:
      'Kata sandi harus terdiri dari minimal 8 karakter',
    confirmPasswordValidation: 'Konfirmasi kata sandi baru',
    passwordsDoNotMatch: 'Kata sandi tidak cocok',
  },
};

export function getPasswordResetValidationCopy(
  locale: SupportedLocale
): PasswordResetValidationCopy {
  return COPY_BY_LOCALE[locale];
}
